export default {
    START_LOGIN:'START_LOGIN',
    LOGIN_SUCCESS:'LOGIN_SUCCESS',
    LOGIN_FAILED:'LOGIN_FAILED',
}